export default {
	byKey: {
		los: {
			key: 'los',
			data: {
				nameDisplay: (
					<>
						LOS<span>Radar geometry</span>
					</>
				),
				group: 'l1',
				availableOrbitalTrajectories: ['asc'],
				availableVisualizations: ['displacement', 'trendDynamics'],
				attributeSets: [
					'ids',
					'psi_estimations',
					'height',
					'psi_reliability',
					'psi_trend_estimation',
					'metadata',
				],
				attributesForTooltip: ['vel_avg', 'cl_dyn'],
			},
		},
		dts: {
			key: 'dts',
			data: {
				nameDisplay: (
					<>
						DTS<span>Steepest terrain slope</span>
					</>
				),
				group: 'l1',
				availableOrbitalTrajectories: ['asc'],
				availableVisualizations: ['displacement', 'trendDynamics'],
				attributeSets: [
					'ids',
					'psi_estimations',
					'height',
					'psi_reliability',
					'psi_trend_estimation',
					'metadata',
				],
				attributesForTooltip: ['vel_avg', 'cl_dyn'],
			},
		},
		vertg: {
			key: 'vertg',
			data: {
				nameDisplay: (
					<>
						Vertical <span>(projected)</span>
					</>
				),
				group: 'l1',
				availableOrbitalTrajectories: ['asc'],
				availableVisualizations: ['displacement', 'trendDynamics'],
				attributeSets: [
					'ids',
					'psi_estimations',
					'height',
					'psi_reliability',
					'psi_trend_estimation',
					'metadata',
				],
				attributesForTooltip: ['vel_avg', 'cl_dyn'],
			},
		},
		vertggps: {
			key: 'vertggps',
			data: {
				nameDisplay: (
					<>
						Vertical{' '}
						<span>
							(calibrated by records from SAMO station<em>*</em>)
						</span>
					</>
				),
				group: 'l2',
				availableOrbitalTrajectories: ['asc'],
				availableVisualizations: [
					'displacement',
					'trendDynamics',
					'trendCluster',
				],
				attributeSets: [
					'ids',
					'psi_estimations',
					'height',
					'psi_reliability',
					'psi_trend_estimation',
					'metadata',
				],
				attributesForTooltip: ['vel_avg', 'cl_dyn', 'cl_clstr'],
			},
		},
	},
};
